import { PERSONALIZADO, GENERICO, DIRECTO } from 'constants/tipoBeneficio';

export const useSetBeneficiados = () => {
  return (beneficiados, tipoBeneficio, form) => {
    const formatedBeneficiados = beneficiados.map((beneficiado) => {
      if (tipoBeneficio === PERSONALIZADO || tipoBeneficio === DIRECTO) {
        return {
          beneficiado: beneficiado.idContabilidad,
          cargo: beneficiado.cargo,
          idBeneficiado: beneficiado.idBeneficiado,
          idContabilidad: beneficiado.idContabilidad,
          idSujetoObligado: beneficiado.idSujetoObligado,
          idTipoAsociacion: beneficiado.idTipoAsociacion,
          nombreBeneficiado: beneficiado.nombreBeneficiado,
          sujetoObligado: beneficiado.sujetoObligado,
          tipoAsociacion: beneficiado.tipoAsociacion
        };
      }
      if (tipoBeneficio === GENERICO) {
        return {
          idSujetoObligado: beneficiado.idSujetoObligado,
          idTipoAsociacion: beneficiado.idTipoAsociacion,
          nombreBeneficiado: beneficiado.nombreBeneficiado,
          sujetoObligado: beneficiado.sujetoObligado,
          tipoAsociacion: beneficiado.tipoAsociacion,
          sujetoObligadoId: beneficiado.idSujetoObligado
        };
      }
      return {
        idSujetoObligado: beneficiado.idSujetoObligado,
        idTipoAsociacion: beneficiado.idTipoAsociacion,
        nombreBeneficiado: beneficiado.nombreBeneficiado,
        sujetoObligado: beneficiado.sujetoObligado,
        tipoAsociacion: beneficiado.tipoAsociacion,
        sujetoObligadoId: beneficiado.idSujetoObligado,
        cargo: beneficiado.cargo
      };
    });
    form.setFieldsValue({ beneficiados: formatedBeneficiados });
  };
};
